export default __webpack_public_path__ + "static/icons.light-b7ed90d9fcc92fdc48a73eea97adbc1c57aac3a470d5906534f88c1aa87ea1cc.png";